import { useRef } from "react";
import useInlineScript from "../../../hooks/useInlineScript";

export default function TikTok({ id, nick }: { id: string; nick: string }): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);
  useInlineScript(ref, `<script async src="https://www.tiktok.com/embed.js?${Date.now()}"></script>`);

  return (
    <div ref={ref}>
      <blockquote
        className={["tiktok-embed"].join(" ")}
        cite={`https://www.tiktok.com/${nick}/video/${id}`}
        data-video-id={id}
        style={{ maxWidth: "605px", minWidth: "325px" }}
      >
        <section>
          <a target="_blank" title={nick} href={`https://www.tiktok.com/${nick}?refer=embed`} rel="noreferrer">
            {nick}
          </a>
        </section>
      </blockquote>
    </div>
  );
}
